// extracted by mini-css-extract-plugin
export default {"content":"ConfirmStep_content__p5pKI"};